import { ZodError } from 'zod';

export type ServerError = {
  message: string;
  statusCode: number;
  errors: Array<{ message: string; path: string }>;
  hasError: boolean;
};

export function serverError(
  message: string,
  statusCode: number = 400,
  errors: Array<{ message: string; path: string }> = [],
) {
  return { message, statusCode, errors, hasError: true } as ServerError;
}

export function unauthorizedError(
  message: string = 'Not authorized',
  errors: Array<{ message: string; path: string }> = [],
) {
  return serverError(message, 401, errors);
}

export function notFoundError(
  message: string = 'Not found',
  errors: Array<{ message: string; path: string }> = [],
) {
  return serverError(message, 404, errors);
}

export function validationError(errorData: ZodError) {
  const zodErrors = errorData.issues.map((err) => ({
    message: err.message,
    path: err.path.join('.'),
  }));

  return serverError('Validation failed', 400, zodErrors);
}

export function isError(error: any): error is ServerError {
  return (
    error !== null &&
    error !== undefined &&
    typeof error === 'object' &&
    'hasError' in error
  );
}
